import * as angular from 'angular';

import { ComponentDefinition, Directory, IScript, IFile, IPreselectedFileType } from '../../../models';
import { IFileManagementService, ILoggerService, IStoreService } from '../../../services';
import { StoreElement } from '../../../stateManagement';
import * as events from '../../../common/events';
import { IRootScope } from 'IRootScope';

class FileManagementStateController implements angular.IComponentController {
    isEditMode: boolean;
    isLoading: boolean;
    items: Directory[];
    loadingMessage: string;
    preSelect: IPreselectedFileType;
    script: IScript;
    selectedItem: Directory;

    private _unsubscribe: () => void;

    static $inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        'fileManagementService',
        'storeService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: IRootScope,
        private _$stateParams: angular.ui.IStateParamsService,
        private _fileManagementService: IFileManagementService,
        private _storeService: IStoreService,
        private _loggerService: ILoggerService) {
    }

    $onInit() {
        this.preSelect = {
            file: this._$stateParams['file'],
            type: this._$stateParams['type']
        };
        this.isEditMode = this._$rootScope.isEditMode;
        this._$scope.$on(events.isEditMode, (event, data) => this.isEditMode = data);
        this._unsubscribe = this._storeService.register(
            s => { /* do nothing */ },
            [StoreElement.Groups]
        );
    }

    $onDestroy(): void {
        this._unsubscribe();
    }

    reloadGroups() {
        this._storeService.dispatchers().groups.getAll(true);
    }

    refresh(): angular.IPromise<Directory> {
        return this._fileManagementService
            .getStructure();
    }

    delete(item: IFile): angular.IPromise<void> {
        return this._fileManagementService
            .deleteFile(item.parent.relativePath, item.name);
    }

    download(item: IFile): angular.IPromise<string> {
        return this._fileManagementService
            .download(item.parent ? item.parent.relativePath : '../', item.name)
            .then((data) => {
                return data;
            });
    }

    onDrop(files: FileList, item: Directory): angular.IPromise<any> {
        return this._fileManagementService
            .upload(files[0], item.relativePath)
            .catch(reason => {
                this._loggerService.logError('Cannot upload file', true, reason);
            });
    }
}

export const wtFileManagementState: ComponentDefinition = {
    componentId: 'wtFileManagementState',
    controller: FileManagementStateController,
    template: require('./fileManagementState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};